(() => {
  const wideRailQuery = window.matchMedia('(min-width: 1200px)');
  const desktopQuery = window.matchMedia('(min-width: 750px)');
  let guidePosition;
  const positionShoppingGuide = () => {
    const guide = document.querySelector('.dhuni-guide')?.closest('.shopify-section');
    const main = guide?.closest('main');
    if (!guide || !main) return;
    if (!guidePosition?.isConnected) {
      guidePosition = document.createComment('Shopping guide desktop position');
      guide.before(guidePosition);
    }
    if (desktopQuery.matches) {
      if (guidePosition.nextSibling !== guide) guidePosition.after(guide);
    } else if (main.lastElementChild !== guide) {
      main.append(guide);
    }
  };

  const positionItemChooser = () => {
    const chooser = document.querySelector('.dhuni-item-chooser')?.closest('.shopify-section');
    const target = document.querySelector(desktopQuery.matches ? '.dhuni-home-slideshow' : '.dhuni-new-arrivals')?.closest('.shopify-section');
    if (!chooser || !target) return;
    if (desktopQuery.matches) {
      if (target.nextElementSibling !== chooser) target.after(chooser);
    } else if (target.nextElementSibling !== chooser) {
      target.after(chooser);
    }
  };

  const positionAnnouncement = () => {
    if (desktopQuery.matches) return;
    const announcement = document.querySelector('.dhuni-news')?.closest('.shopify-section');
    const slideshow = document.querySelector('.dhuni-home-slideshow')?.closest('.shopify-section');
    const searchBar = document.querySelector('.dhuni-home-search-bar')?.closest('.shopify-section');
    if (announcement && slideshow && slideshow.nextElementSibling !== announcement) slideshow.after(announcement);
    // Keep the search bar directly under the announcement, wherever it ends up.
    if (searchBar && announcement && announcement.nextElementSibling !== searchBar) announcement.after(searchBar);
  };

  const sideRailDisabledForPreview = new URLSearchParams(window.location.search).get('no_side_rail') === '1';

  const syncCategoryDisclosureMode = () => {
    document.querySelectorAll('[data-dhuni-side-rail] .dhuni-category-menu details').forEach((details) => {
      if (!details.hasAttribute('data-dhuni-was-open')) {
        details.dataset.dhuniWasOpen = details.open ? 'true' : 'false';
      }

      if (details.classList.contains('dhuni-category-group--names')) details.open = true;
    });
    document.querySelectorAll('[data-dhuni-side-rail] .dhuni-category-group--names details').forEach((details) => {
      details.open = true;
    });
  };

  const mountSideRail = () => {
    positionItemChooser();
    positionAnnouncement();
    positionShoppingGuide();
    if (sideRailDisabledForPreview) return;
    const categorySection = document.querySelector('.dhuni-category-menu')?.closest('.shopify-section');
    const storeSection = document.querySelector('.dhuni-side-store-info')?.closest('.shopify-section');
    const reviewSection = document.querySelector('.dhuni-side-review')?.closest('.shopify-section');

    if (!categorySection || !storeSection || !reviewSection) return;
    if (categorySection.parentElement?.matches('[data-dhuni-side-rail]')) {
      syncCategoryDisclosureMode();
      return;
    }

    const main = categorySection.closest('main') || document.querySelector('main');
    if (!main) return;

    let rail = main.querySelector(':scope > [data-dhuni-side-rail]');
    if (!rail) {
      rail = document.createElement('aside');
      rail.className = 'dhuni-side-rail';
      rail.dataset.dhuniSideRail = '';
      rail.setAttribute('aria-label', '商品を探す');
      main.insertBefore(rail, categorySection);
    }

    rail.prepend(reviewSection);
    rail.prepend(storeSection);
    rail.append(categorySection);
    main.classList.add('dhuni-has-side-rail');
    syncCategoryDisclosureMode();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountSideRail, { once: true });
  } else {
    mountSideRail();
  }

  document.addEventListener('shopify:section:load', mountSideRail);
  wideRailQuery.addEventListener('change', syncCategoryDisclosureMode);
  desktopQuery.addEventListener('change', () => { positionItemChooser(); positionAnnouncement(); positionShoppingGuide(); });
})();
